/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Payment_Create_PlanInputs */

const en_case_payment_create_plan = /** @type {(inputs: Case_Payment_Create_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create payment plan`)
};

const pt_br2_case_payment_create_plan = /** @type {(inputs: Case_Payment_Create_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criar plano de pagamento`)
};

/**
* | output |
* | --- |
* | "Create payment plan" |
*
* @param {Case_Payment_Create_PlanInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_payment_create_plan = /** @type {((inputs?: Case_Payment_Create_PlanInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Payment_Create_PlanInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_payment_create_plan(inputs)
	return pt_br2_case_payment_create_plan(inputs)
});